import { Component, Input, type OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
  selector: 'app-automation-time-options',
  templateUrl: './automation-time-options.component.html',
})
export class AutomationTimeOptionsComponent implements OnInit {
  @Input() form: FormGroup
  @Input() showLabel = true
  ngOnInit(): void {}
}
